import { FC, memo } from 'react';
import { Card } from 'shared/ui/Card';
import { Form } from 'features/Form';
import { UserRequestDto } from 'shared/api';
import { REGISTRATION_FORM_FIELDS } from '../../constants/registrationConstants';
import styles from './RegistrationForm.module.scss';

interface RegistrationFormProps {
  onSubmit: (data: UserRequestDto) => void;
  onCancel?: () => void;
  loading?: boolean;
}

export const RegistrationForm: FC<RegistrationFormProps> = memo(({
  onSubmit,
  onCancel,
  loading = false,
}) => (
  <Card>
    <div className={styles.registrationForm}>
      <h1 className={styles.title}>
        Завершение регистрации
      </h1>
      <p className={styles.description}>
        Для завершения регистрации заполните следующие поля:
      </p>
      <Form
        fields={REGISTRATION_FORM_FIELDS}
        onSubmit={onSubmit}
        onCancel={onCancel}
        loading={loading}
        submitText="Завершить регистрацию"
        cancelText="Отмена"
      />
    </div>
  </Card>
));

RegistrationForm.displayName = 'RegistrationForm';
